import { useEffect, useRef, useState, useCallback } from 'react';
const OBSERVER_THRESHOLD = 0.5;
export const useScrollToTargetChild = ({ rootElt, targetElt, callback, callbackThrottle = 0, }) => {
    const alreadyCalledRef = useRef(false);
    useEffect(() => {
        if (rootElt && targetElt) {
            let initialCheck = true;
            let resetAlreadyCalled;
            const observer = new IntersectionObserver((e) => e.forEach((event) => {
                if (event.isIntersecting) {
                    if (initialCheck) {
                        initialCheck = false;
                        return;
                    }
                    if (alreadyCalledRef.current && resetAlreadyCalled) {
                        window.clearTimeout(resetAlreadyCalled);
                        resetAlreadyCalled = null;
                    }
                    else {
                        callback?.();
                    }
                    alreadyCalledRef.current = true;
                    resetAlreadyCalled = setTimeout(() => {
                        alreadyCalledRef.current = false;
                    }, callbackThrottle);
                }
                else {
                    initialCheck = false;
                }
            }), {
                root: rootElt,
                rootMargin: '0px',
                threshold: OBSERVER_THRESHOLD,
            });
            observer.observe(targetElt);
            return () => {
                alreadyCalledRef.current = false;
                if (resetAlreadyCalled) {
                    window.clearTimeout(resetAlreadyCalled);
                    resetAlreadyCalled = null;
                }
                observer.disconnect();
            };
        }
        return () => null;
    }, [rootElt, targetElt]);
};
export const useScrollToLastChild = ({ childItems, callback, callbackThrottle = 0, }) => {
    const [rootElt, setRootElt] = useState(null);
    const [targetElt, setTargetElt] = useState(null);
    useEffect(() => {
        const lastElementChild = rootElt?.lastElementChild || null;
        if (lastElementChild !== targetElt) {
            setTargetElt(lastElementChild);
        }
    }, [rootElt, childItems]);
    const setRootRef = useCallback((elt) => {
        setRootElt(elt);
        setTargetElt(elt?.lastElementChild || null);
    }, []);
    useScrollToTargetChild({
        rootElt,
        targetElt,
        callback,
        callbackThrottle,
    });
    return { setRootRef };
};
//# sourceMappingURL=use-scroll-to-target-child.js.map